import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import ParticipationHistoryLayer from '../components/ParticipationHistoryLayer'

const ParticipationHistoryPage = () => {
  return (
    <>
      <MasterLayout>
        <ParticipationHistoryLayer />
      </MasterLayout>
    </>
  )
}

export default ParticipationHistoryPage
